import React, { useEffect, useState } from "react";
import styles from "./AdsPricing.module.css";
import { InputField, SubmitButton } from "../../../components";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { PagesMiddleware } from "../../../Store/Middlewares/PagesMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { useDispatch } from "react-redux";

const AdsPricing = () => {

  const [ListingFee, setListingFee] = useState("");
  const [daysValidation, setdaysValidation] = useState("");
  const dispatch = useDispatch()

  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(PagesMiddleware.getAdsPricing())
      .then((res) => {
        setListingFee(res.fee);
        setdaysValidation(res.durationInDays);
      })
      .catch((err) => { console.log("error", err) });
  }

  const onAddPricing = () => {
    if (!ListingFee) {
      dispatch(showAlert({ message: "Please enter listing fee", type: "warning" }))
    }
    else if (!daysValidation) {
      dispatch(showAlert({ message: "Please enter days validation", type: "warning" }))
    }
    else if (isNaN(ListingFee)) {
      dispatch(showAlert({ message: "Please enter valid listing fee", type: "warning" }))
    }
    else if (isNaN(daysValidation)) {
      dispatch(showAlert({ message: "Please enter valid days validation", type: "warning" }))
    }
    else {
      const data = { fee: ListingFee, durationInDays: daysValidation };
      dispatch(PagesMiddleware.createAdsPricing(data))
        .then((res) => {
          setListingFee(res.fee);
          setdaysValidation(res.durationInDays);
        })
        .catch((err) => { console.log("error", err) });
    }
  }

  return (
    <div className={styles.AccountContent}>
      <HeadingComponent text={"Manage Ads Pricing"} fontSize={20} padding={'0px'} />

      <InputField
        label={"Listing Fee"}
        style={{ marginTop: "30px" }}
        placeholder={"$10.00"}
        value={ListingFee}
        onChange={(e) => setListingFee(e.target.value)}

      />

      <InputField
        label={"Days validation / No. of days"}
        style={{ marginTop: "20px" }}
        placeholder={"10"}
        value={daysValidation}
        onChange={(e) => setdaysValidation(e.target.value)}
      />


      <SubmitButton
        onClick={onAddPricing}
        title={"Save"}
        primary
        style={{ width: "100%", marginTop: "10px" }}

      />
    </div>
  );
};

export default AdsPricing;
